
import {AppConfigService} from './app-config.service';

export function AppConfigFactory(
    config: AppConfigService,
    /* Extra dependencies */
): () => Promise<any> {
    return (): Promise<any> => {
        return new Promise<void>((resolve, reject) => {
            config.init().then((res) => {
                resolve();
            }).catch(() => {
                reject();
            });

        });
    };
}
